import { createEvent, sample } from 'effector'
import { createAction } from 'effector-action'
import { runtime, version } from '~/app/environment'
import { model as config, remote } from '~/shared/config'
import { postpone } from '~/shared/effector'
import { wire } from './wires-events'
import { disable, enable, initialize } from './wrapper'

/**
 * Process bootstrap trigger.
 */
export const init = createEvent()
const awaited = createEvent()

/**
 * Feature flag that gates all analytics delivery.
 */
const $enabled = config.get(remote.tria_isAnalyticsEnabled)
// .map((enabled) => (__NODE_ENV__ === 'development' ? true : enabled)) // force enable analytix in local development

/**
 * Backend listener URL with environment-specific migrations/fallbacks.
 */
const $domain = config
  .get(remote.tria_analyticsListenerDomain)
  .map((domain) => {
    try {
      // hardcode dev domain for local development environment
      if (__NODE_ENV__ === 'development') {
        const url = new URL(domain)
        url.hostname = 'by-analytics-server-go.spnode.net'
        return url.toString()
      }

      // otherwise return address as is
      return domain
    } catch (ignore) {
      // if it's not a valid url, return as is as well
      return domain
    }
  })

//
//
//

/**
 * Defer startup until remote config is fully loaded.
 */
postpone({
  clock: init,
  until: config.$ready,
  target: awaited,
})

sample({
  clock: awaited,
  target: wire,
})

// initialize analytix on app start and any analytix domain change
sample({
  clock: [awaited, $domain],
  source: $domain,
  filter: (domain) => typeof domain === 'string' && domain.length > 0,
  fn: (domain) => ({
    baseUrl: domain,
    configAccountCode: 'setplex',
    appName: runtime.app.name,
    appId: runtime.app.domain,
    appReleaseVersion: version,
  }),
  target: initialize,
})

//
// Enable / disable analytix
//

createAction([awaited, $enabled, $domain], {
  source: { $enabled, $domain },
  target: { enable, disable },
  fn: (target, { enabled, domain }) =>
    enabled && typeof domain === 'string' && domain.length > 0
      ? target.enable()
      : target.disable(),
})
